import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=43337c6a&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=43337c6a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43337c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43337c6a')) {
      api.createRecord('43337c6a', component.options)
    } else {
      api.reload('43337c6a', component.options)
    }
    module.hot.accept("./videoPlay.vue?vue&type=template&id=43337c6a&scoped=true", function () {
      api.rerender('43337c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/training/videoPlay.vue"
export default component.exports